<span [ngSwitch]="status">
  <span class="badge bg-danger text-light" *ngSwitchCase="'CANCELED'">Annulée</span>
  <span class="badge bg-white text-dark" *ngSwitchCase="'DRAFT'">Ouverte</span>
  <span class="badge bg-secondary text-light" *ngSwitchCase="'SUBMITED'">Soumise</span>
  <span class="badge bg-info text-light" *ngSwitchCase="'ACK'">En traitement</span>
  <span class="badge bg-success text-light" *ngSwitchCase="'CONFIRMED'">Confirmé</span>
  <span class="badge bg-primary text-light" *ngSwitchCase="'SHIPPED'">Expédiée</span>
</span>